export type UiSkin = "classic" | "modern"
export type UiTheme = "light" | "dark"

/**
 * Namespaced so it can never collide with `i18nextLng`, which i18next stores
 * on this same origin.
 */
export const UI_SKIN_STORAGE_KEY = "cardiolyse.ui-mode";
export const UI_THEME_STORAGE_KEY = "cardiolyse.ui-theme";
export const UI_STORAGE_VERSION_KEY = "cardiolyse.ui-storage-version";
export const UI_STORAGE_VERSION = "2";

export const UI_SKIN_QUERY_PARAM = "ui";
export const UI_THEME_QUERY_PARAM = "theme";

export const DEFAULT_UI_SKIN: UiSkin = "modern";
export const DEFAULT_UI_THEME: UiTheme = "light";
